import * as styles from "./Tree.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { TreeProps } from "./Tree.types";
import { TreeItem } from "./TreeItem";

export function Tree({ items, onSelect, className }: TreeProps): JSX.Element {
  return (
    <div data-slot="tree" className={clsx(styles.root, className)}>
      {items.map((node, index) => (
        <TreeItem
          key={node.id ?? `${node.label}-${index}`}
          node={node}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
